<template>
  <RouterView />
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
#app {
  font-family: "Microsoft YaHei";
}
.mb-0{
  margin-bottom: 0 !important;
}
.p-0{
  padding: 0 !important;
}
.border-0{
  border: 0 !important;
}
.bg-unset{
  background: unset !important;
}
.opacity-1{
  opacity: 1 !important;
}
.d-block{
  display: block !important;
}
.container {
  margin-right: auto;
  margin-left: auto;
}

/* 超小屏幕 (xs) 小于 576px */
@media (max-width: 575.98px) {
  .container {
    max-width: 100%;
  }
}

/* 小屏幕 (sm) ≥576px */
@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

/* 中等屏幕 (md) ≥768px */
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

/* 大屏幕 (lg) ≥992px */
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

/* 超大屏幕 (xl) ≥1200px */
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* 超超大屏幕 (xxl) ≥1400px */
@media (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}
</style>
